'use client';

import { useAuth0 } from '@auth0/auth0-react';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import {
    consumeAuth0AutoshipEnroll,
    hasPendingAuth0AutoshipEnroll,
    isAuth0CallbackPath,
    useDecisions,
} from '@libs/common-next';

import { dataLayerPush } from '../gtm/dataLayerPush';

/**
 * Fires once on the destination page after an Auth0 login/signup that started
 * from in-store Autoship enrollment. Login and create-account analytics consume
 * separate signals and can fire for the same completed authentication.
 */
export function useAuth0AutoshipEnrollEvent() {
    const isAuth0Enabled = useDecisions('auth0');
    const { isAuthenticated, isLoading } = useAuth0();
    const pathname = usePathname();

    useEffect(() => {
        if (
            !isAuth0Enabled ||
            isLoading ||
            !isAuthenticated ||
            isAuth0CallbackPath(pathname ?? '') ||
            !hasPendingAuth0AutoshipEnroll()
        ) {
            return;
        }

        if (!consumeAuth0AutoshipEnroll()) {
            return;
        }

        dataLayerPush({ event: 'complete_autoship_in_store_setup' });
    }, [isAuth0Enabled, isAuthenticated, isLoading, pathname]);
}
